import { Box, Button, Checkbox, FormControlLabel, MenuItem, TextField, Typography, useTheme } from "@mui/material"
import { useAppDispatch } from "../../../Redux/store"
import { setProgress, setSubtitle } from "../Slices/accountCreationSlice";
import { useState } from "react";
import { TermsOfServiceModal } from "./TermsOfServiceModal";

interface DataConsentProps {}
export const DataConsent = (props: DataConsentProps) =>{
    /* ******************** Hooks ******************** */
    const dispatch = useAppDispatch();
    /* ******************** Variables ******************** */
    const [open, setOpen] = useState<boolean>(true);
    /* ******************** Functions ******************** */
    dispatch(setSubtitle('Review our terms, then we’ll create your account.'));
    const handleReviewClick = () => {
        setOpen(true);
    }
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <>
            <Box display={"flex"} flexDirection={"row"} justifyContent={"center"} alignItems={"center"} gap={2}>
                <Button variant="contained" size="large" color="secondary" onClick={() => dispatch(setProgress(90))}>Back</Button>
                <Button variant="contained" size="large" onClick={handleReviewClick}>Review</Button>
            </Box>
            <TermsOfServiceModal
                open={open}
                setOpen={setOpen}
            />
        </>
    )
}